var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }